import { Box, Stack, StackProps, styled } from "@mui/material";
import { HTMLMotionProps } from "motion/react";

const BasePillWrapper = ({
  direction = "row",
  ...rest
}: StackProps) => {
  return <Stack direction={direction} {...rest} />;
};

export const PillWrapper = styled(BasePillWrapper)(({ theme }) => ({
  borderRadius: 18,
  height: 18,
  overflow: "hidden",
  background: theme.palette.charts[3],
}));

interface IPillInnerProps extends HTMLMotionProps<any> {
  percentage: number;
}

export const PillInner = styled(Box)<IPillInnerProps>(
  ({ theme, percentage }) => ({
    background: theme.palette.charts[1],
    minWidth: `${percentage}%`,
    willChange: "min-width",
    transition: "min-width 0.2s ease-in-out",
  })
);
